"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Typography = require("../Typography");

var _IconThumbsUp = _interopRequireDefault(require("../Icons/IconThumbsUp"));

var _IconThumbsDown = _interopRequireDefault(require("../Icons/IconThumbsDown"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var getColor = function getColor(value, theme) {
  switch (value) {
    case true:
      return {
        dark: theme.status.succes,
        light: theme.status.succesLight
      };

    case false:
      return {
        dark: theme.status.error,
        light: theme.status.errorLight
      };

    default:
      return {
        dark: '#cccccc',
        light: '#f0f1f3'
      };
  }
};

var ProspectPreferenceBox = function ProspectPreferenceBox(_ref) {
  var label = _ref.label,
      value = _ref.value,
      DisplayIcon = _ref.DisplayIcon,
      className = _ref.className,
      otherProps = _objectWithoutProperties(_ref, ["label", "value", "DisplayIcon", "className"]);

  var theme = (0, _react.useContext)(_styledComponents.ThemeContext);

  var _getColor = getColor(value, theme),
      dark = _getColor.dark,
      light = _getColor.light;

  return /*#__PURE__*/_react.default.createElement(Container, _extends({
    className: className,
    color: dark
  }, otherProps), /*#__PURE__*/_react.default.createElement(InnerContainer, null, /*#__PURE__*/_react.default.createElement(IconContainer, {
    color: light
  }, /*#__PURE__*/_react.default.createElement(DisplayIcon, {
    color: dark
  })), /*#__PURE__*/_react.default.createElement(Label, null, label)), value !== null && /*#__PURE__*/_react.default.createElement(StatusIconContainer, {
    color: dark
  }, value === true && /*#__PURE__*/_react.default.createElement(_IconThumbsUp.default, {
    color: theme.status.succesLight
  }), value === false && /*#__PURE__*/_react.default.createElement(_IconThumbsDown.default, {
    color: theme.status.errorLight
  })));
};

var Container = _styledComponents.default.div.withConfig({
  displayName: "Container"
})(["display:grid;border:", ";border-radius:0.8rem;box-shadow:0 4px 8px rgba(0,0,0,0.04),0 0 2px rgba(0,0,0,0.06),0 0 1px rgba(0,0,0,0.04);width:100%;max-width:23rem;"], function (_ref2) {
  var color = _ref2.color;
  return "solid ".concat(color, " 1px");
});

var InnerContainer = _styledComponents.default.div.withConfig({
  displayName: "InnerContainer"
})(["grid-row:1;grid-column:1;display:flex;align-items:center;padding:1.6rem;"]);

var Label = (0, _styledComponents.default)(_Typography.H4).withConfig({
  displayName: "Label"
})(["text-align:center;font-weight:400;word-break:break-word;margin-left:2.4rem;"]);

var IconContainer = _styledComponents.default.div.withConfig({
  displayName: "IconContainer"
})(["display:flex;justify-content:center;align-items:center;flex-shrink:0;width:4.4rem;height:4.4rem;background-color:", ";border-radius:50%;"], function (_ref3) {
  var color = _ref3.color;
  return color;
});

var StatusIconContainer = _styledComponents.default.div.withConfig({
  displayName: "StatusIconContainer"
})(["grid-row:1;grid-column:1;display:flex;justify-content:center;align-items:center;width:3.2rem;height:3.2rem;background-color:", ";border-radius:50%;justify-self:flex-end;margin-top:-1.6rem;margin-right:-1.6rem;"], function (_ref4) {
  var color = _ref4.color;
  return color;
});

ProspectPreferenceBox.propTypes = {
  /** Label to be shown in the container. */
  label: _propTypes.string.isRequired,

  /** This will handle the status color: true || null || false */
  value: _propTypes.bool,

  /** React element FUNCTION which has the icon that will be displayed. */
  DisplayIcon: _propTypes.func.isRequired,

  /** Extra classes to be passed to the element. */
  className: _propTypes.string,

  /** Extra props to be passed to the element. */
  otherProps: _propTypes.object
};
ProspectPreferenceBox.defaultProps = {
  value: null
};
var _default = ProspectPreferenceBox;
exports.default = _default;